import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    position: 'fixed',
    display: 'flex',
    justifyContent: 'center',
    left: 0,
    [theme.breakpoints.up('lg')]: {
      left: theme.spacing(-4.5),
      top: theme.spacing(4.5),
    },
    top: 0,
    zIndex: 1,
  },

  video: {
    width: '100%',
    maxWidth: theme.spacing(168.75),
    height: '100%',
  },
}));
